// Joya Headquarter — data, settings, menu and employee strings (Hebrew). Same keys in data.he.js and data.en.js.
export default {
  "joya.data.title": "מקורות ואיכות נתונים",
  "joya.data.kind.SALES_CHECKS": "חשבונות (סועדים והזמנות)",
  "joya.data.kind.SALES_ITEMS": "מכירות לפי מנה",
  "joya.data.kind.EMPLOYEES": "עובדים",
  "joya.data.kind.ATTENDANCE": "נוכחות",
  "joya.data.kind.PAYROLL": "רכיבי שכר",
  "joya.data.kind.INQUIRIES": "פניות וביקורות",
  "joya.data.sub": "מה חסר, מה ישן ומה לא ממופה — בכל סניף. נתון חסר לא נחשב כאפס.",
  "joya.data.integrations": "חיבורים למערכות",
  "joya.data.noLive": "המכירות, שעות השעון, העובדים והשכר נקראים מממשק Allegro. שום דבר מהם לא מועתק לכאן.",
  "joya.data.notConnected": "לא מחובר",
  "joya.data.method.FILE_IMPORT": "ייבוא קובץ",
  "joya.data.method.MANUAL": "הזנה ידנית",
  "joya.data.kinds": "סוגי נתונים",
  "joya.data.cred.set": "פרטי גישה: מוגדרים בקובץ הסביבה של השרת",
  "joya.data.cred.notSet": "פרטי גישה: לא מוגדרים",
  "joya.data.exportOnly": "יצוא בלבד: {what}",
  "joya.data.sources": "מקורות הנתונים",
  "joya.data.lastData": "נתון אחרון",
  "joya.data.lastPeriod": "חודש אחרון",
  "joya.data.rows": "שורות",
  "joya.data.noRows": "אין נתונים",
  "joya.data.stale": "לא עדכני",
  "joya.data.issues": "בעיות שנמצאו",
  "joya.data.noIssues": "לא נמצאו בעיות.",
  "joya.data.sev.HIGH": "חשוב",
  "joya.data.sev.MEDIUM": "בינוני",
  "joya.data.sev.LOW": "נמוך",
  "joya.data.sev.INFO": "לידיעה",
  "joya.data.goMenu": "לתפריט",
  "joya.data.goEmployees": "לעובדים ומיפוי מזהים",
  "joya.data.goRules": "להגדרת משמרות",
  "joya.data.goImport": "לייבוא",
  "joya.data.issue.NO_SALES_CHECKS": "ב-Allegro אין הזמנות Beecomm לסניף הזה.",
  "joya.data.issue.STALE_SALES": "הזמנות ה-Beecomm ב-Allegro לא עודכנו {days} ימים.",
  "joya.data.issue.NO_SALES_ITEMS": "ב-Allegro אין מכירות מנות לסניף הזה.",
  "joya.data.issue.STALE_SALES_ITEMS": "מכירות המנות ב-Allegro לא עודכנו {days} ימים.",
  "joya.data.issue.MISSING_SALES_DAYS": "ב-{count} ימים ב-28 הימים האחרונים אין מכירות ב-Beecomm — ימים שהמסעדה הייתה סגורה (נבדק עד היום האחרון ש-Allegro טענה).",
  "joya.data.issue.CHECKS_WITHOUT_DINERS": "{count} מתוך {of} חשבונות בלי מספר סועדים.",
  "joya.data.issue.CHECKS_WITHOUT_CLOSE_TIME": "{count} מתוך {of} חשבונות בלי שעת סגירה (נדרש לסועדים בו-זמנית).",
  "joya.data.issue.CHECKS_WITHOUT_AMOUNT": "{count} מתוך {of} חשבונות בלי סכום.",
  "joya.data.issue.UNMATCHED_ITEM_CODES": "{count} מנות שנמכרו ב-28 הימים האחרונים לא נמצאות בתפריט כאן.",
  "joya.data.issue.NO_MENU": "לסניף אין תפריט במערכת.",
  "joya.data.issue.DISHES_WITHOUT_INGREDIENTS": "{count} מתוך {of} מנות בלי רשימת רכיבים.",
  "joya.data.issue.RECIPE_LINES_WITHOUT_QTY": "{count} רכיבים במנות בלי כמות. זה מותר — כמויות לא חובה.",
  "joya.data.issue.NO_ATTENDANCE": "ב-Allegro אין שורות שעון של Tabit לסניף הזה. מעלים את הדוח המפורט של Tabit ב-Allegro.",
  "joya.data.issue.STALE_ATTENDANCE": "שורות השעון של Tabit ב-Allegro בנות {days} ימים.",
  "joya.data.issue.UNMATCHED_EMPLOYEE_IDS": "Allegro לא הצליחה להתאים חלק משמות ה-Tabit לעובד אחד. השעות שלהם לא נספרות לאף אחד.",
  "joya.data.issue.ATTENDANCE_WITHOUT_ROLE": "ל-{count} שורות שעון יש שם תפקיד בלי תפקיד Joya (28 הימים האחרונים).",
  "joya.data.issue.NO_SHIFTS_DEFINED": "לא הוגדרו משמרות לסניף — אי אפשר לתכנן איוש.",
  "joya.data.issue.NO_PAYROLL": "ב-Allegro אין חודש שכר שמור לסניף הזה.",
  "joya.set.title": "הגדרות",
  "joya.set.tabUsers": "משתמשים והרשאות",
  "joya.set.tabLocations": "סניפים",
  "joya.set.tabNumbers": "מספרים שהמערכת משתמשת בהם",
  "joya.set.tabIntegrations": "חיבורים ופרטי גישה",
  "joya.set.allegroRole": "תפקיד ב-Allegro",
  "joya.set.inactiveAllegro": "לא פעיל",
  "joya.set.noAccess": "אין גישה",
  "joya.set.usersIntro": "המשתמשים והרשאות שלהם נקבעים רק באדמין של Allegro (אותו אימייל ואותה סיסמה). מנהל ב-Allegro הוא מנהל רשת כאן, ומנהל מסעדה רואה את הסניפים שלו. כדי להוסיף או לשנות משתמש, עושים זאת באדמין של Allegro.",
  "joya.set.locations": "סניפים",
  "joya.set.allLocations": "כל הסניפים",
  "joya.set.payroll": "גישה לשכר",
  "joya.set.yes": "כן",
  "joya.set.no": "לא",
  "joya.set.noUsers": "אין משתמשים באדמין של Allegro.",
  "joya.set.adminOnly": "רק הנהלת הרשת יכולה לשנות את זה.",
  "joya.set.code": "קוד",
  "joya.set.codeHint": "אותיות לטיניות, ספרות, - ו-_ . הקוד משמש בייבוא, לא השם.",
  "joya.set.name": "שם",
  "joya.set.active": "פעיל",
  "joya.set.inactive": "לא פעיל",
  "joya.set.addLocation": "סניף חדש",
  "joya.set.editLocation": "עריכת סניף",
  "joya.set.numbersIntro": "כל מספר שהמלצות המערכת משתמשות בו גלוי כאן. שינוי משפיע על המלצות חדשות בלבד.",
  "joya.set.readOnly": "לקריאה בלבד — רק הנהלת הרשת משנה.",
  "joya.set.saved": "נשמר",
  "joya.set.badNumber": "צריך מספר 0 או יותר",
  "joya.set.group.replenishment": "הזמנות והשלמת מלאי",
  "joya.set.group.staffing": "תכנון משמרות",
  "joya.set.group.labor": "עלות עבודה",
  "joya.set.group.dataQuality": "איכות נתונים",
  "joya.set.k.historyLists": "מספר רשימות קודמות ללמידה",
  "joya.set.h.historyLists": "כמה רשימות סופיות אחרונות של הסניף נבדקות.",
  "joya.set.k.halfLifeLists": "זמן מחצית (ברשימות)",
  "joya.set.h.halfLifeLists": "אחרי כמה רשימות משקל של רשימה ישנה יורד לחצי.",
  "joya.set.k.minExamplesForQty": "מינימום רשימות לכמות",
  "joya.set.h.minExamplesForQty": "פחות מזה — לא מוצעת כמות, המנהל משלים.",
  "joya.set.k.minExamplesForRatio": "מינימום רשימות ליחס למכירות",
  "joya.set.h.minExamplesForRatio": "כמה הזמנות עם נתוני מכירות מלאים צריך כדי להשתמש ביחס כמות/מכירות.",
  "joya.set.k.dueFraction": "חלק מהמרווח הרגיל",
  "joya.set.h.dueFraction": "פריט \"מגיע\" להזמנה כשעבר החלק הזה מהמרווח הרגיל בין הזמנות (0.8 = 80%).",
  "joya.set.k.shortageBumpPct": "תוספת אחרי חוסר (%)",
  "joya.set.h.shortageBumpPct": "כמה להגדיל את הכמות כשדווח חוסר מאז ההזמנה האחרונה.",
  "joya.set.k.removedSuppressShare": "שיעור הסרות",
  "joya.set.h.removedSuppressShare": "אם המנהל הסיר פריט מוצע בחלק כזה מהרשימות — הוא עובר ל\"לבדוק\".",
  "joya.set.k.approvedOnlyWeight": "משקל רשימה מאושרת שלא סומנה כהוזמנה",
  "joya.set.h.approvedOnlyWeight": "רשימה שהוזמנה בפועל שווה 1.",
  "joya.set.k.coldStartDays": "ימים להתחלה בלי היסטוריה",
  "joya.set.h.coldStartDays": "בלי רשימות קודמות: כמה ימי מכירות אחרונים מוצגים כמידע.",
  "joya.set.k.historyWeeks": "שבועות היסטוריה לתחזית",
  "joya.set.h.historyWeeks": "התחזית היא החציון של אותו יום בשבוע בשבועות האלה.",
  "joya.set.k.minDaysForForecast": "מינימום ימים לתחזית",
  "joya.set.h.minDaysForForecast": "פחות ימים עם נתונים — הביטחון בתחזית נמוך.",
  "joya.set.k.learnedAdjustMinPlans": "מינימום תכניות ללמידה מעריכות",
  "joya.set.h.learnedAdjustMinPlans": "שינוי שהמנהל עשה לפחות כך הרבה פעמים, באותו כיוון, מוצג כהתאמה נלמדת.",
  "joya.set.k.learnedAdjustWindow": "מספר תכניות אחרונות שנבדקות",
  "joya.set.h.learnedAdjustWindow": "כמה תכניות מאושרות אחרונות נבדקות.",
  "joya.set.k.employerCostFactorEstimate": "מקדם עלות מעסיק (הערכה)",
  "joya.set.h.employerCostFactorEstimate": "לא בשימוש יותר: עלות העבודה מגיעה מה-Admin של Allegro (כללי השכר שלו).",
  "joya.set.k.staleDays": "ימים עד \"לא עדכני\"",
  "joya.set.h.staleDays": "נתון שלא עודכן יותר ימים מזה מסומן כלא עדכני.",
  "joya.set.k.longShiftHours": "משמרת ארוכה (שעות)",
  "joya.set.h.longShiftHours": "משמרת ארוכה מזה מסומנת לבדיקה בהכנת השכר.",
  "joya.set.intText1": "המכירות (Beecomm), שעות השעון (Tabit), העובדים והשכר נקראים בזמן אמת מממשק הניהול של Allegro. Joya לא שומרת מהם דבר; תשובות נשמרות בזיכרון ל-5 דקות בלבד.",
  "joya.set.intText2": "כתובת הממשק היא משתנה השרת ALLEGRO_API_URL. הממשק עונה רק על המחשב שלו, ולכן joya-hq רצה ליד מערכת הניהול של Allegro (או דרך מנהרת SSH). Instagram ו-Google עדיין מוזנים ידנית; המפתחות שלהם יישמרו בקובץ הסביבה של השרת.",
  "joya.set.envName": "שם המשתנה בשרת",
  "joya.set.noEnv": "אין עדיין",
  "joya.menu.title": "תפריט ורכיבים",
  "joya.menu.tabMenu": "תפריט",
  "joya.menu.tabIngredients": "רכיבים",
  "joya.menu.addItem": "מנה חדשה",
  "joya.menu.editItem": "עריכת מנה",
  "joya.menu.code": "קוד בקופה",
  "joya.menu.codeHint": "מכירות מהקופה מותאמות למנה לפי הקוד הזה, לא לפי השם.",
  "joya.menu.name": "שם",
  "joya.menu.category": "קטגוריה",
  "joya.menu.active": "פעיל",
  "joya.menu.inactive": "לא פעיל",
  "joya.menu.ingCount": "{count} רכיבים, {noQty} מהם בלי כמות",
  "joya.menu.noIngList": "אין רשימת רכיבים",
  "joya.menu.qtyOptional": "כמויות ברכיבים לא חובה. רכיב בלי כמות עוזר להבין ביקוש, אבל לא משמש לחישוב צריכה \"מדויק\".",
  "joya.menu.recipe": "רכיבי המנה",
  "joya.menu.ingredient": "רכיב",
  "joya.menu.qty": "כמות למנה",
  "joya.menu.qtyEmpty": "ריק = לא ידוע",
  "joya.menu.unit": "יחידה",
  "joya.menu.addLine": "הוספת רכיב",
  "joya.menu.search": "חיפוש רכיב…",
  "joya.menu.newIngredient": "רכיב חדש",
  "joya.menu.noLines": "עוד אין רכיבים למנה.",
  "joya.menu.noItems": "אין מנות לסניף. אפשר לייבא תפריט מהקופה.",
  "joya.menu.orderUnit": "יחידת הזמנה",
  "joya.menu.dishes": "במנות: {n}",
  "joya.menu.addIngredient": "רכיב חדש",
  "joya.menu.editIngredient": "עריכת רכיב",
  "joya.menu.ingCode": "קוד (לא חובה)",
  "joya.menu.noIngredients": "לא נמצאו רכיבים.",
  "joya.menu.badQty": "כמות צריכה להיות מספר גדול מ-0, או ריקה",
  "joya.menu.posItemsHint": "קוד פריט מהקופה שלא נמצא בתפריט מופיע בעמוד איכות הנתונים.",
  "joya.emp.title": "עובדים",
  "joya.emp.fromAllegro": "העובדים מגיעים ממערכת הניהול של Allegro. משנים אותם שם; Joya רק קוראת אותם.",
  "joya.emp.unmatchedTitle": "שורות שעון בלי עובד",
  "joya.emp.unmatchedHelp": "Allegro לא הצליחה להתאים את שמות ה-Tabit האלה לעובד אחד בבטחה, ולכן השעות שלהם לא נספרות לאף אחד. מתקנים את השם או הטלפון ב-Allegro.",
  "joya.emp.allMatched": "כל שורות השעון של 35 הימים האחרונים שייכות לעובד.",
  "joya.emp.rowsCount": "{n} שורות",
  "joya.emp.location": "סניף",
  "joya.emp.role": "תפקיד",
  "joya.emp.allegroRoles": "תפקידים ב-Allegro",
  "joya.emp.roleNotMapped": "לא ממופה — הגדרות ← תפקידים",
  "joya.emp.wage": "שכר לשעה (ברוטו)",
  "joya.emp.inactive": "לא פעיל",
  "joya.emp.contractor": "קבלן",
  "joya.emp.noEmployees": "אין עובדים ב-Allegro לסניפים האלה.",
  "joya.emp.filter": "סינון לפי שם…",
  "joya.data.connected": "מחובר",
  "joya.data.method.API": "ממשק חי (קריאה בלבד)",
  "joya.data.goRoles": "לשמות התפקידים",
  "joya.data.issue.ALLEGRO_UNREACHABLE": "אין גישה לממשק Allegro, ולכן אי אפשר להציג נתוני מקור: {message}",
  "joya.data.issue.SOURCE_NOT_LOADED": "ב-Allegro עדיין אין את הנתונים האלה ({source}): {reason}",
  "joya.data.issue.UNMAPPED_ROLE_NAMES": "לחלק משמות התפקידים מ-Allegro אין תפקיד Joya. בוחרים אחד בהגדרות ← שמות תפקידים.",
  "joya.set.locationsIntro": "הסניפים והחברות באים מ-Allegro (רשימת הסניפים של האדמין); Joya לא שומרת אותם. סניף חדש מופיע לבד. סניף בלי הזמנות Beecomm ב-60 הימים האחרונים (למשל סניף שנסגר) מסומן לא פעיל ולא מופיע בבחירת הסניף.",
  "joya.set.branchId": "מזהה הסניף ב-Allegro",
  "joya.set.refresh": "לקרוא מ-Allegro שוב עכשיו",
  "joya.set.refreshed": "נקרא שוב",
  "joya.set.tabRoles": "שמות תפקידים",
  "joya.set.rolesIntro": "ב-Allegro התפקידים כתובים במילים (מלצר, פס חם…). בוחרים לאיזה תפקיד Joya כל שם נספר. שעות עם שם שאין לו תפקיד Joya לא נספרות לאף תפקיד.",
  "joya.set.roleEmployees": "{n} עובדים ב-Allegro",
  "joya.set.noJoyaRole": "— בלי תפקיד Joya —",
  "joya.set.apiUrl": "כתובת הממשק",
};
